/**
 * Constants and configuration for DOM utilities
 * 
 * This module provides:
 * - Data attribute names and selectors
 * - Configuration constants
 * - HTML sanitization for security
 */
import DOMPurify from 'dompurify';

export const MAX_STRUCTURE_SEARCH_ATTEMPTS = 20;

export const DATA_ATTRIBUTES = {
    STRUCTURE_INDEX: 'data-structure-index',
    PARAM_INDEX: 'data-param-index',
    LABEL: 'data-label'
} as const;

export const SELECTORS = {
    STRUCTURE_INDEX: `[${DATA_ATTRIBUTES.STRUCTURE_INDEX}]`,
    PARAM_INDEX: `[${DATA_ATTRIBUTES.PARAM_INDEX}]`,
    VARIABLE_SPAN: `[${DATA_ATTRIBUTES.LABEL}]`
} as const;

const PURIFY_CONFIG = {
    ALLOWED_TAGS: ['span', 'div', 'br', 'strong', 'em'],
    ALLOWED_ATTR: ['class', 'data-label', 'data-structure-index', 'data-param-index', 'contenteditable'],
    KEEP_CONTENT: true
};

export function sanitizeHTML(html: string): string {
    if(!html) return '';
    return DOMPurify.sanitize(html, PURIFY_CONFIG);
}
